import React, { Component } from "react";
import Img from "react-image";
import Close from "../../../../../Icons/Close";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";

const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);
class ModalNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
      listNotifications: [],
    };
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModaleNotifications();
    }, 400);
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.dataNotifications !== this.props.dataNotifications &&
      this.props.dataNotifications.data !== null
    ) {
      this.setState({
        listNotifications: this.props.dataNotifications.data.notifications,
      });
    }
  }
  render() {
     let sorteNotifications = !_.isEmpty(this.state.listNotifications)
      ? this.state.listNotifications.sort((a, b) =>
          moment(b.dateTime).diff(a.dateTime)
        )
      : [];
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin modalNotifications show actif modal-large"
          id="modalNotifications"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeModal}
                  />
                </button>
                <div className="modal-body fiche-enfant">
                  <h5 className="modal-title mb-5">
                    Quoi de neuf pour {this.props.kidItem.prenom}?
                  </h5>
                  <p className="bottom-space"></p>
                  <section className="content-section">
                    <div className="fake-table-style">
                      {!_.isEmpty(this.props.NotificationList)
                        ? this.props.NotificationList.map((element, index) => (
                            <div className="tbody" key={index}>
                              <div className="tr row">
                                <div className="col-3">
                                  {moment(element.dateTime).format(
                                    "D/MM/YYYY HH[h]mm"
                                  )}
                                </div>
                                <div className="col-9">
                                  {element.message.fr}
                                </div>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </section>
                  <div className="d-flex justify-content-center">
                    <div className="row align-items-center">
                      <button
                        type="button"
                        className="btn-gradient btn-valid margin-left"
                        data-dismiss="modal"
                        onClick={this.closeModal}
                      >
                        <IconValider /> OK
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

const mapStateToProps = (state) => ({
  dataNotifications: state.ficheEnfant.Journee,
});

export default connect(mapStateToProps, {})(ModalNotifications);
